export enum IlsType {
  sierra = 'sierra',
  polaris = 'polaris',
}
